import Loadable from "../../react-loadable";
import middleware from "../../middleware";

const WeaAssociativeSearch = Loadable({
  loader: () => import("../base/wea-associative-search"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

const WeaAssociativeSearchMult = Loadable({
  loader: () => import("../base/wea-associative-search-mult"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

class main extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { props } = this;
    if (props.mult) {
      delete props.mult;
      return <WeaAssociativeSearchMult {...props} />;
    }
    return <WeaAssociativeSearch {...props} />;
  }
}

const Com = middleware(main, "WeaAssociativeSearch");

export { WeaAssociativeSearch, WeaAssociativeSearchMult };

export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-associative-search/index.js